import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { uploadPricingFileAPI } from "../../api/pricingFiles";

const OverwriteUploadFileModal = ({
  fileDetails,
  handelModal,
  modal,
  handleSetMutation,
  existingFilesCount = 0,
}) => {
  const [loading, setLoading] = useState(false);
  const toggle = () => handelModal(!modal);
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      if (fileDetails.files.length === 0) {
        toast.error("Please select a file to upload.", {
          position: "top-center",
        });
        return;
      }
      const formData = new FormData();
      for (let pfIndex = 0; pfIndex < fileDetails?.files.length; pfIndex++) {
        formData.append("pricing-files", fileDetails?.files[pfIndex]);
      }

      const response = await uploadPricingFileAPI(formData);

      toast.success(response.data.message, {
        position: "top-center",
      });
      fileDetails.setUploadFilesForModal([]);
      handleSetMutation({});
      handelModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "server error", {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  // const fileDateFormated = moment(fileDetails?.original_filename).format(
  //   "MM-DD-YYYY"
  // );
  // Are you sure you want to overwrite the current pricing file for
  // date "{fileDateFormated}" ?
  return (
    <div>
      <li className="preview-item">
        <Modal isOpen={modal} toggle={toggle} style={{ maxWidth: "600px" }}>
          <ModalHeader
            toggle={toggle}
            close={
              <button className="close" onClick={toggle}>
                {/* <Icon name="cross" /> */}
              </button>
            }
          >
            Overwrite Pricing File
          </ModalHeader>
          <ModalBody>
            <p className="fw-bold fs-16px">
              {existingFilesCount
                ? existingFilesCount +
                " pricing files already exist. Are you sure you want to overwrite them?"
                : null}
            </p>
            <div
              className=" w-100 d-flex justify-content-end"
              style={{ marginTop: "20px" }}
            >
              <Button
                disabled={loading}
                color="white"
                onClick={() => {
                  toggle();
                  fileDetails.setUploadFilesForModal([]);
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={loading}
                color="danger"
                onClick={() => {
                  handleDelete(fileDetails);
                }}
              >
                {loading ? <Spinner color="white" size="sm" /> : "Overwrite"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </li>
    </div>
  );
};

export default OverwriteUploadFileModal;
